import Model        from "./Model";
import Area         from "./Area";
import City         from "./City";
import User         from "./User";
import Currency     from "./Currency";
import Supplier     from "./Supplier";
import Media        from "./Media";
import Event        from "./Event";
import Industry     from "./Industry";
import Review       from "./Review";

export default class Work extends Model
{
    constructor( options = {} )
    {
        super('/home/works/');

        this.setOptions(options);
    }

    setOptions( options = {} )
    {
        this.id         = options.id           || null;
        this.name       = options.name         || null;

        this.walls      = options.walls        || null;
        this.stand_type = options.stand_type   || null;
        this.likes      = options.likes        || 0;
        this.rate       = options.rate         || 0;
        this.permalink  = options.permalink    || null;

        this.photos     = Media.makeCollection(options.photos   || {});
        this.counts     = options.counts || [];

        this.photo      = typeof options.photo    === 'Media'      ? options.photo     : new Media( options.photo        || {} );  //new User(options.user                 || {});
        this.user       = typeof options.user     === 'User'       ? options.user      : new User( options.user          || {} );  //new User(options.user                 || {});
        this.supplier   = typeof options.supplier === 'Supplier'   ? options.supplier  : new Supplier( options.supplier  || {} );  //new Supplier(options.supplier         || {});
        this.event      = typeof options.event    === 'Event'      ? options.event     : new Event( options.event        || {} );  //new Event(options.event               || {});
        this.city       = typeof options.city     === 'City'       ? options.city      : new City( options.city          || {} );  //new City(options.city                 || {});
        this.area       = typeof options.area     === 'Area'       ? options.area      : new Area( options.area          || {} );  //new Area(options.area                 || {});
        this.currency   = typeof options.currency === 'Currency'   ? options.currency  : new Currency( options.currency  || {} );  //new Currency(options.currency         || {});
        this.industry   = typeof options.industry === 'Industry'   ? options.industry  : new Industry( options.industry  || {} );  //this.industry   = options.industry    || null;
        this.review     = typeof options.review   === 'Review'     ? options.review    : new Review( options.review      || {} );

    }

    toJson()
    {
        return {
            'id'            : this.id,
            'user'          : this.user.toJson(),
            'supplier'      : this.supplier.toJson(),
            'name'          : this.name,
            'event'         : this.event.toJson(),
            'city'          : this.city.toJson(),
            'area'          : this.area.toJson(),
            'currency'      : this.currency.toJson(),
            'industry'      : this.industry.toJson(),
            'walls'         : this.walls,
            'stand_type'    : this.stand_type,
            'photo'         : this.photo.toJson(),
            'photos'        : this.photos,
            'likes'         : this.likes,
            'rate'          : this.rate,
            'permalink'     : this.permalink,
        }
    }

    isHostesses() {
        return this.supplier.sector ? this.supplier.sector.isHostesses() : false;
    }

    isStands() {
        return this.supplier.sector ? this.supplier.sector.isStands() : false;
    }
}



// WEBPACK FOOTER //
// ./resources/js/models/Work.js